import { render, staticRenderFns } from "./SaleReturnView.vue?vue&type=template&id=40362e4e"
import script from "./SaleReturnView.vue?vue&type=script&lang=js"
export * from "./SaleReturnView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports